// Re-export react-hot-toast configured component
import { Toaster } from "react-hot-toast";
import React from "react";

const ToastProvider = () => (
  <Toaster
    position="bottom-right"
    gutter={12}
    toastOptions={{
      duration: 3000,
      style: {
        borderRadius: "12px",
        background: "#1e293b",
        color: "#f8fafc",
        fontSize: "14px",
        fontWeight: "500",
        padding: "12px 16px",
      },
      success: {
        iconTheme: { primary: "#3b82f6", secondary: "#fff" },
      },
      error: {
        iconTheme: { primary: "#ef4444", secondary: "#fff" },
      },
    }}
  />
);

export default ToastProvider;
